import memoize from 'lodash/memoize';

export type GlobalFeatureFlags = { [key: string]: 'true' };

export function getGlobalFeatureFlagsInternal(): GlobalFeatureFlags {
  const content = document
    .querySelector('meta[name="pr-feature-flags"]')
    ?.getAttribute('content');

  return JSON.parse(content ?? '{}');
}

export const getGlobalFeatureFlags = memoize(getGlobalFeatureFlagsInternal);
